import { Component, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-menu-forum',
  templateUrl: './menu-forum.component.html',
  styleUrls: ['../../app.component.css', './menu-forum.component.css']
})

export class MenuForumComponent {

  @Input() forum;

  constructor( ) {
    moment.locale('es');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/menu-forum/menu-forum.component.ts